module.exports = __webpack_public_path__ + "img/gift.8242375f.svg";